// Api/UserImportApi.ts
import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export const UserImportApi = {
  uploadFemaCsv(file: File) {
    const form = new FormData();
    form.append("file", file);

    const auth = getAuthHeader(); // e.g. { headers: { Authorization: 'Bearer …' } }

    return axios.post(`${API_URL}/api/user/femaupload`, form, {
      headers: {
        ...(auth.headers ?? auth), // merge Authorization in
        // DO NOT set Content-Type; Axios will set with boundary
      },
      responseType: "json",
      // optional:
      // withCredentials: true,
      // onUploadProgress: (e) => console.log(Math.round((e.loaded/e.total!*100))+'%'),
    });
  },
};
